import API from "@aws-amplify/api";
import { getCurrentJwt } from "../../../util/jwt/decryptToken";

export async function queryQuestionEnhacement(userPrompt, clientName) {
  const options = {
    headers: {
      Authorization: getCurrentJwt()
    },
    body: {
      message: userPrompt,
      clientName: clientName
    },
  };
  let sleepTime = 1000
  let res = null
  while (true) {
    sleepTime *= 2
    try {
      res = await API.post(process.env.REACT_APP_AMPLIFY_API, '/orion/prompt-engineering', options).then(data => data)
      if (res.hasOwnProperty('messages')) {
        return (res.messages[0].content).toString().replace(/^['"]|['"]$/g, '');
      }
    }
    catch (e) {
      console.log(e)
    }
    await new Promise(resolve => setTimeout(resolve, sleepTime));
  }
}


// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageUtil/queryQuestionEnhacement.js